import { render, staticRenderFns } from "./ChangeBuildingGroupLog.vue?vue&type=template&id=52aa4676&lang=pug&"
import script from "./ChangeBuildingGroupLog.vue?vue&type=script&lang=ts&"
export * from "./ChangeBuildingGroupLog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports